import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxImageUpload,
  DxItem,
} from 'devextreme-vue/html-editor';

export const devExtremeEditor = {
  components: {
    DxHtmlEditor,
    DxToolbar,
    DxMediaResizing,
    DxImageUpload,
    DxItem,
  },
  data() {
    return {
      imageUploadType: ['file', 'url'],
      imageUploadMode: "base64",
      multilineToolbar: true,
      mediaResize: true,
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '20pt', '24pt', '36pt'],
      fontValues: ['Arial', 'iranyekan', 'Koodak', 'BKoodak', 'Nazanin', 'Ordibehesht',
                  'Amine', 'Samim', 'Shabnam', 'ShabnamB', 'Tahoma'],
      headerValues: [false, 1, 2, 3, 4, 5],
      editorHeight: "350px",

      editorToolbar: [
        {id: 1, name: "undo"},
        {id: 2, name: "redo"},
        {id: 3, name: "separator"},
        {id: 4, name: "bold"},
        {id: 5, name: "italic"},
        {id: 6, name: "strike"},
        {id: 7, name: "underline"},
        {id: 42, name: "superscript"},
        {id: 8, name: "separator"},
        {id: 9, name: "alignLeft"},
        {id: 10, name: "alignCenter"},
        {id: 11, name: "alignRight"},
        {id: 12, name: "alignJustify"},
        {id: 13, name: "separator"},
        {id: 14, name: "orderedList"},
        {id: 15, name: "bulletList"},
        {id: 16, name: "separator"},
        {id: 17, name: "color"},
        {id: 18, name: "background"},
        {id: 19, name: "separator"},
        {id: 20, name: "link"},
        {id: 21, name: "image"},
        {id: 22, name: "separator"},
        {id: 23, name: "clear"},
        {id: 24, name: "codeBlock"},
        {id: 25, name: "blockquote"},
        {id: 26, name: "separator"},
        {id: 35, name: "increaseIndent"},
        {id: 36, name: "decreaseIndent"},
        {id: 37, name: "variable"},
        {id: 41, name: "separator"},
        {id: 27, name: "insertTable"},
        {id: 28, name: "deleteTable"},
        {id: 29, name: "insertRowAbove"},
        {id: 30, name: "insertRowBelow"},
        {id: 31, name: "deleteRow"},
        {id: 32, name: "insertColumnLeft"},
        {id: 33, name: "insertColumnRight"},
        {id: 34, name: "deleteColumn"},
        {id: 38, name: "cellProperties"},
        {id: 39, name: "tableProperties"},
        {id: 40, name: "insertHeaderRow"},
      ],
    };
  },
};
